const initialState = {}


function loggingReducer(state = initialState, action) {
    console.log(action)
    return state
}

export default loggingReducer